/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamCompanyDropdownQueryResponse,
  GetApiV1ExamCompanyDropdownQueryParams,
  GetApiV1ExamCompanyDropdown400,
  GetApiV1ExamCompanyDropdown401,
  GetApiV1ExamCompanyDropdown500,
} from "../../types/examSharedController/GetApiV1ExamCompanyDropdown.ts";

function getGetApiV1ExamCompanyDropdownUrl() {
  const res = { method: "GET", url: `/api/v1/exam/company-dropdown` as const };
  return res;
}

/**
 * @description Retorna a lista de empresas para uso em componentes de seleção. Quando informado o courseId, retorna apenas as empresas associadas ao curso; caso contrário, retorna todas as empresas ativas. **(Requer Authorization para autenticação)**
 * @summary Lista de empresas para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/company-dropdown}
 */
export async function getApiV1ExamCompanyDropdown(
  params?: GetApiV1ExamCompanyDropdownQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamCompanyDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamCompanyDropdown400
      | GetApiV1ExamCompanyDropdown401
      | GetApiV1ExamCompanyDropdown500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamCompanyDropdownUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
